import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-line-icon',
    templateUrl: './line-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LineIconComponent {}
